import { PrimeReactProvider } from 'primereact/api';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './resources/styles/app.scss';
import { store } from './store.js';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

ReactDOM.createRoot(document.getElementById('root')).render(
    <StrictMode>
        <GoogleOAuthProvider clientId={googleClientId}>
            <Provider store={store}>
                <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                    <PrimeReactProvider>
                        <App />
                    </PrimeReactProvider>
                </BrowserRouter>
            </Provider>
        </GoogleOAuthProvider>
    </StrictMode>
);
